export default {
  async changeLang({ commit }, params) {
    commit('setLang', params.lang);
  },
};
